/**
 * 住所検索
 */
window.searchAddress = function (searchKey) {

    let postal_code1 = $('.input-postal-code1').val();
    let postal_code2 = $('.input-postal-code2').val();

    if( postal_code1 === '' || postal_code2 === '' ){
        return;
    }

    let zipcode = postal_code1+postal_code2;
    searchKey = searchKey.replace(':zipcode', zipcode);

    // ローディング&非活性
    $('#address-spinner i').hide();
    $('#address-spinner div').show();
    $('#address-spinner').prop('disabled', true);

    axios.get(searchKey, {

    }).then(response => {

        // ローディング&非活性　解除
        $('#address-spinner i').show();
        $('#address-spinner div').hide();
        $('#address-spinner').prop('disabled', false);

        let address = JSON.parse(JSON.stringify(response.data.results));
        if(!address){
            alert("住所が取得できませんでした");
        }else{
            let completeAddress = address[0].address1 + address[0].address2 + address[0].address3;
            $('.input-address1').val(completeAddress);

        }
    }).catch(error => {
        alert("住所が取得できませんでした");
        // ローディング&非活性　解除
        $('#address-spinner i').show();
        $('#address-spinner div').hide();
        $('#address-spinner').prop('disabled', false);
        console.error(error);
    });
}
